
export function getImgurl(id) {
  try {
    if (id) {
      return `https://static.cricbuzz.com/a/img/v1/152x152/i1/c${id}/i.jpg`;
    } else {
      return "/default-player.png";
    }
  } catch (e) {
    return "/default-player.png";
  }
}
export function checkwk(p) {
  if (p == 'wicketkeeper' || p == 'wk-batsman' || p == 'wicket keeper' || p == 'wk-batter') {
    return true;
  }
  return false;
}

export function checkar(p) {
  if (
    p == 'allrounder'
    || p == 'batting allrounder'
    || p == 'bowling allrounder'
    || p == 'all rounder'
  ) {
    return true;
  }
  return false;
}

export function isUnAnnounced(id, players) {
  return true;
}
